import { useState } from "react";
import SidebarComp from "../../../components/Sidebar";
import Header from "../../../components/Header";
import "../styles/policydetails.css"
import Escalation_matrix from "../../Escalation_matrix";


const Escalation_matrixHome = () => {

    const [collapsed , setCollapsed] = useState(false)

    return (
      <>
        <div className="dashboard-main-cover-wrapper">
            <Header/>
            <div className="dashboard-inner-main-cover-wrapper">
              <div className="dashboard-sidebar">
                  <SidebarComp setCollapsed={setCollapsed} collapsed={collapsed}/>
              </div>
              <div className={ collapsed ? "dashboard-content-cover-closed-wrapper" : "dashboard-content-cover-wrapper"}>
                  <Escalation_matrix/>
              </div>
            </div>
        </div>
      </>
    );
  };
  
  export default Escalation_matrixHome;